import * as R from "ramda";
import { Action } from "redux";
import { AppState } from "./appState";
import ACTION_TYPE from "./ActionTypes";
import { IFilterForm } from "./overagesFilterFormActions";

export type typeExceptionSearchFilterForm = {
  type: ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE;
  exceptionSearchFilterForm: IFilterForm;
};

/**
 * Redux action to update DispatchForm in Redux State
 * @param exceptionFilterForm - the params we use for the dispatch api put request Obtained from DispatchForm component.
 */

export const saveExceptionSearchFilterForm = (
  exceptionSearchFilterForm: IFilterForm,
): typeExceptionSearchFilterForm => ({
  type: ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE,
  exceptionSearchFilterForm: exceptionSearchFilterForm,
});

export const saveExceptionSearchFilterFormReducer = (
  state: AppState,
  action: Action,
): AppState => {
  if (action.type !== ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    exceptionSearchFilterForm: (action as typeExceptionSearchFilterForm)
      .exceptionSearchFilterForm,
  });
};

// I want same above redux action for cleared exception search filter form. So I will create new action type and reducer for that.

export type typeClearedFilterForm = {
  clearedFilterForm: IFilterForm;
  type: ACTION_TYPE.CLEARED_FILTER_FORM_STATE;
};

export const saveClearedFilterForm = (
  clearedFilterForm: IFilterForm,
): typeClearedFilterForm => ({
  type: ACTION_TYPE.CLEARED_FILTER_FORM_STATE,
  clearedFilterForm: clearedFilterForm,
});

export const saveClearedFilterFormReducer = (
  state: AppState,
  action: Action,
): AppState => {
  if (action.type !== ACTION_TYPE.CLEARED_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    clearedFilterForm: (action as typeClearedFilterForm).clearedFilterForm,
  });
};
